import { CLIENT_VAL_OTP, CLIENT_VAL_OTP_ERROR, CLIENT_VAL_OTP_HIDE_ERROR, CLIENT_VAL_OTP_START_LOADER, CLIENT_VAL_OTP_STOP_LOADER, LOGIN_SHOW_POPUP, } from "../interface/IClientValOTP";
const initState = {
    data: {
        jwtToken: "",
        cnsntLst: [],
        accData: {
            accType: "",
            accs: {
                bseMfstwt: false,
                cdslAuToSl: false,
                cdslEsFlg: false,
                emailCnsnt: false,
                eml: "",
                eqAccID: "",
                eqAccName: "",
                eqAlgoClnt: "",
                eqBrId: "",
                eqBrk: "",
                eqBrkCode: "",
                eqDob: "",
                eqEmpCat: "",
                eqRmRt: "",
                eqstwt: false,
                llt: "",
                mfInf: false,
                mobCnsnt: false,
                prfId: "",
                rstpwd: false,
                rstusr: false,
                ucmCd: "",
                uid: "",
                wtspCnsnt: "",
                empOrDependent: "",
            },
            userId: "",
            defaultPrds: {},
            excs: [],
            ordTypes: [],
            dfPrdsMTF: null,
            prds: [],
            val: [],
            mrgAccDts: {
                emIds: [],
                phNos: [],
                uids: [],
            },
            othAccDts: {
                accTyp: "",
                isAct: false,
                isOnline: false,
                uid: "",
            },
            mrgSts: "",
            mtf: "",
            adhrEQ: { stat: "", brkCode: "" },
            adhrCOM: { stat: "", brkCode: "" },
            opCnst: [],
            coAccID: "",
            eqAccID: "",
            eqRmRt: "",
            prefAccTyp: null,
            eqAccName: "",
            coAccName: "",
            prfId: "",
            wtspCnsnt: null,
        },
        accTyp: "",
        userID: "",
        emaildId: "",
        accountCode: "",
        lgnSrc: "",
        isImpersonated: false,
        userName: "",
        empOrDependent: "",
    },
    loader: false,
    showLoginPopup: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const ClientValOTP = (state = initState, action) => {
    var _a;
    switch (action.type) {
        case CLIENT_VAL_OTP:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case CLIENT_VAL_OTP_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case CLIENT_VAL_OTP_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case CLIENT_VAL_OTP_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case LOGIN_SHOW_POPUP:
            return Object.assign(Object.assign({}, state), { showLoginPopup: (_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.showLoginPopup });
        case CLIENT_VAL_OTP_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default ClientValOTP;
